export function buildSecretHeaders(): HeadersInit {
  const buildSecret = process.env.WEBSITE_API_BUILD_SECRET

  return buildSecret ? { 'X-Website-Build-Secret': buildSecret } : {}
}
